import React, { useState, useEffect } from 'react'
import RightArrow from "../../../../../assets/images/RightArrow@2x.png"
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../../../CustomComponents/Loader'
import { width } from '../../../../CustomComponents/DynamicCard/DynamicCardStyles'
import CustomTextInput from '../../../../CustomComponents/CustomtextInput'
import DynamicCard from '../../../../CustomComponents/DynamicCard'
import { appTheme } from '../../../../../helpers/utils/Utils'
import { addLineBreaks,  } from '../../../../../utils'
import logFirebaseEvents from '../../../../LogFirebaseEvents'
import CardHeading from '../../../../CustomComponents/CardHeading'
import { withOidcSecure } from '@axa-fr/react-oidc'
 
const SavinGoalFields = ({  cardFooter, onBack, onNext, onNameChange   }) => {
 
  const { t } = useTranslation();
  const navigate = useNavigate()
  const dispatch = useDispatch();
 
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue);
  const [nameError, setNameError] = useState()
  const [isLoading, setIsLoading] = useState(false);
  const [isNext, setIsNext] = useState(false);
  const name = useSelector(state => state.savingGoals.name);
  const amount = useSelector((state) => state.savingGoals.amount);
  const handleBackClick = () => {
    logFirebaseEvents("Saving_Goals", "Back_Saving_Goals_Clicked", "Back_Saving_Goals_Clicked","", "")
    navigate('/Toolkit/SavingGoals/ManageSavingGoal')
  }
  
  const handleNextClick = () => {
    logFirebaseEvents("Saving_Goals", "Next_Saving_Goals_Clicked", "Next_Saving_Goals_Clicked","", "")
    if (!name) setNameError('Enter Savings Goal');
    if (name && !nameError) onNext("SavingGoalAmountField");
    dispatch({ type: 'SAVING_GOALS', payload: { key: "amount", value: amount } });
  }
 
  const handleOnBlur=(e)=>{
    if (!name) setNameError('Enter Savings Goal');
    else if (name <= 0){
      setNameError('Please enter name ')
    }
    else setNameError('')
  }
 
 
  const nameValidation = () => {
    if (!name) setNameError('Enter Savings Goal');
    else if (name <= 0){
      setNameError('Enter Savings Goal')
    }
    else {
      setNameError(null)
      setIsNext(true);
    }
 
 
  }
  useEffect(() => {
    if (name) nameValidation();
 
    if (!name) setIsNext(false);
 
  }, [name])
 
  useEffect(() => {
    dispatch({ type: 'ACCOUNT_BALANCE', payload: {accountBalance: null } });
  }, [])
 
  
  
 
  const children = () => {
    return (
      <>
        {/* {cardHeader} */}
        <div className='sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
         sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px]
              text-[var(--text-clrs)] mt-6 sm:mx-0 mx-4'>{t("spending_alert_amount_content1")}
          <span className='text-[var(--text-body-clrs)]'>{t("Saving_Goal_For")}</span>
 
          <div className='font-hanken-grotesk mt-5 font-[300] md:text-[18px] sm:text-[12px] text-[14px] sm:leading-[18px] md:leading-[24px] leading-[25px] text-[var(--modal-text-heading-clr)]'>{addLineBreaks(t('Track_Your_Savings_Goal_Text_Updated'))}</div>
        </div>
 
        <div className='w-full flex justify-center'>
          <div className="sm:w-[80%] w-full">
            {/* BODY */}
            <div className='md:my-32 sm:my-16 mt-10 mb-[10rem] sm:mx-0 mx-4'>
              <div className='sm:w-[50%] w-full flex flex-col justify-center'>
                <CustomTextInput name={t("Savings goal")}
                  onKeyDown={(event) => {
                    if (event.key == "Enter") {
                      event.preventDefault(); event.target.style.opacity = 0.8;
                      setTimeout(() => { event.target.style.opacity = 1; }, 200);
                    }
                  }}
                    onChange={(event) => {
                     const inputValue = event.target.value;
                     if (inputValue.length <= 50) {
                      dispatch({ type: 'SAVING_GOALS', payload: { key: "name", value: inputValue } });
                    } else {
                      console.log('Input length exceeds 50 characters');
                    }
                     }}
                 
                  onBlur={(event)=> handleOnBlur(event)}
                  value={name ? `${name}` : ''}
                  error={nameError}
                  placeholder={"Name"}
                  inputWidth={`w-full`}
                  autoFocus={true}
                />
              </div>
            </div>
          </div>
 
        </div>
        {/* FOOTER */}
 
        {cardFooter(handleBackClick, handleNextClick,'','', isNext)}
      </>
    )
  }
  return (
    <>
      <DynamicCard  
        header={false}
        CardRadius={true}
        cardWidth={width.homeCard}
        HeaderRadius={true}
        isWhite={appThemeData.isWhiteBgForCard}
        isDarkForKudzu={appThemeData.isDarkBgForCard}
        backgroundColor={'--cardHeading-bg'}
        HeaderContent={
            <>
                <CardHeading heading={t('Add_Saving_Goal')} />
            </>
        }
        footer={true} >
        {children()}
      </DynamicCard>
      {isLoading && <Loader />}
    </>
  )
}
 
export default withOidcSecure(SavinGoalFields)